export default {
  path: 'reviews',
  name: 'reviews',
  redirect: { name: 'reviews.listing' },
  component: () =>
    import(/* webpackChunkName: "reviews" */ '@/views/Home/Reviews'),
  children: [
    {
      path: '/',
      name: 'reviews.listing',
      component: () =>
        import(
          /* webpackChunkName: "reviews" */ '@/views/Home/Reviews/ReviewList'
        )
    },
    {
      path: '/reviews/:id',
      name: 'reviews.details',
      component: () =>
        import(
          /* webpackChunkName: "reviews" */ '@/views/Home/Reviews/ReviewDetails'
        )
    }
  ]
}
